import { ImageWithFallback } from "./ImageWithFallback";
import imgLifestyle1 from "../../assets/landing/uae-2.jpg";
import imgLifestyle2 from "../../assets/landing/uae-5.jpg";
import imgLifestyle3 from "../../assets/landing/uae-6.jpg";

export function LandingAboutSection() {
  return (
    <section className="lp-py-16 lp-px-6 lp-relative lp-overflow-hidden">
      <div className="lp-max-6xl lp-mx-auto">
        <div className="lp-grid lp-grid-cols-1 md-cols-2 lp-gap-12 lp-items-center">
          
          {/* Left Column: About Content Text */}
          <div>
            <p
              className="lp-text-blue lp-text-xs lp-uppercase lp-tracking-wide lp-mb-3"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              About HubScroll
            </p>
            <h2
              className="lp-text-dark lp-mb-6"
              style={{
                fontFamily: "'Fraunces', serif",
                fontWeight: 600,
                letterSpacing: "-0.025em",
                fontSize: "clamp(2rem, 4.5vw, 3.2rem)",
                lineHeight: 1.1,
              }}
            >
              Connecting Venues with People
            </h2>
            
            <div
              className="lp-text-muted lp-leading-relaxed lp-flex lp-flex-col lp-gap-4"
              style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300, fontSize: "1.05rem" }}
            >
              <p>
                HubScroll is a venue discovery platform designed for the UAE hospitality industry.
              </p>
              <p>
                The mobile app helps people discover cafés, restaurants, bars, lounges, and nightlife venues across Dubai and the Emirates.
              </p>
              <p>
                At the same time, HubScroll helps hospitality businesses reach new customers by giving them visibility in a modern discovery platform used by people actively exploring the city's best venues.
              </p>
              <p className="lp-text-dark lp-font-medium">
                HubScroll connects great places with people who love discovering them.
              </p>
            </div>
          </div>

          {/* Right Column: Visual overlapping floating photo collage */}
          <div className="lp-flex lp-justify-center lp-items-center lp-py-8">
            <div className="lp-collage-container">
              {/* Image 1 - Rotated left */}
              <div className="lp-collage-img lp-collage-img-1">
                <ImageWithFallback
                  src={imgLifestyle1}
                  alt="UAE venue dining layout"
                  className="lp-w-full lp-h-full lp-object-cover lp-r-lg"
                />
              </div>
              
              {/* Image 3 - Rotated right */}
              <div className="lp-collage-img lp-collage-img-3">
                <ImageWithFallback
                  src={imgLifestyle3}
                  alt="Nightlife spot in Dubai"
                  className="lp-w-full lp-h-full lp-object-cover lp-r-lg"
                />
              </div>

              {/* Image 2 - Straight in center foreground */}
              <div className="lp-collage-img lp-collage-img-2" style={{ transform: "scale(1.05)" }}>
                <ImageWithFallback
                  src={imgLifestyle2}
                  alt="Coffee shop environment"
                  className="lp-w-full lp-h-full lp-object-cover lp-r-lg"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
